import { message } from 'antd';
import { axiosApi } from '../axios-api';

export async function fetchOrganizationFontsData(organizationId) {
  try {
    const { data } = await axiosApi.get(`v2/projects/fonts/organization/${organizationId}`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export function buildFontUploadFormData(file, organizationId) {
  const formData = new FormData();
  formData.append('font', file, file.name);
  formData.append('name', file.name);
  formData.append('organization', organizationId);
  return formData;
}

export async function postOrganizationFont(formData) {
  await axiosApi.post('/v2/projects/fonts/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function deleteFontRequest(fontId) {
  await axiosApi.delete(`/fonts/${fontId}`);
}

export async function deleteFileRequest(fileId) {
  await axiosApi.delete(`/files/${fileId}`);
}
